<nav class="cg-sidebar layout-menu-wrapper" (click)="appMain.onSidebarClick($event)">
    <div class="cg-sidebar-brand">
        <a routerLink="/" class="cg-sidebar-logo" aria-label="Carreiras Galegas">
            <img src="assets/layout/images/cg-dark.svg" alt="Carreiras Galegas" />
        </a>
        <button type="button" class="cg-sidebar-close" (click)="appMain.onMenuButtonClick($event)" aria-label="Cerrar menú">
            <lucide-icon [img]="X" [size]="19"></lucide-icon>
        </button>
    </div>
    <div class="layout-menu-container cg-sidebar-nav">
        <ul class="layout-menu">
            <ng-container *ngFor="let item of model; let i = index;">
                <ng-container *ngxPermissionsOnly="item.roles">
                    <li app-menuitem *ngIf="!item.separator && item.show" [item]="item" [index]="i" [root]="true"></li>
                    <li *ngIf="item.separator" class="menu-separator"></li>
                </ng-container>
            </ng-container>
        </ul>
    </div>
</nav>
